import React from "react";
import { NavLink } from "react-router";
import { useParams } from "react-router";
import Wrapper from "../hooks/wrapper";

import "../Components.css";
import artData from "../data/designs.json";

function Products() {
  const params = useParams();
  // www.example.com/{params}
  const category = params.categories;
  // App.js에서 Route를 design:categories를 지정한 부분
  // www.example.com/design/2d 로 접속하면 params.categories는 2d가 됨

  const productionArt = artData.info
    .filter((data) => data.categories === category)
    .map((data, index) => {
      return (
        <div key={index}>
          <div className="ArtThumb">
            <img
              src={`https://portfolio.gyeong.net/static/media/${data.thumb}`}
              alt="···"
              loading="lazy"
            />
          </div>
          <div className="ArtDesc">
            <span style={{ fontWeight: 700 }}>{data.name}</span>
            <span>{data.desc}</span>
          </div>
        </div>
      );
    });
  return <div className="ArtContainer">{productionArt}</div>;
}

function Designs() {
  const params = useParams();
  const categories = params.categories;
  return (
    <Wrapper>
      <div className="Pages">
        <div className="PageTitle">
          <span>{categories.toUpperCase()} DESIGN</span>
          <NavLink to="/">← Previous</NavLink>
        </div>
        <div className="PageContent">
          <div>
            <span className="PageSubtitle">PRODUCTION</span>
            <Products />
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Designs;
